import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'
import Skeleton from 'components/ds/Skeleton'
import styles from './Loader.module.scss'

const Loader = ({ variant = 'skeleton', rows = 4 }) => {
  if (variant === 'spinner') {
    return (
      <div className='d-flex align-items-center justify-content-center h-100'>
        <CircularProgress size={45} color='primary' />
      </div>
    )
  }

  return (
    <div className={styles.loader} role="status" aria-label="Loading">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton
          key={i}
          shape="text"
          height={14}
          width={i === rows - 1 ? '55%' : '100%'}
        />
      ))}
    </div>
  )
}

Loader.propTypes = {
  variant: PropTypes.oneOf(['skeleton', 'spinner']),
  rows: PropTypes.number,
}

export default Loader
